import { ApolloProvider } from '@apollo/client';
import { useApollo } from '@ui/utils/createApolloClient';
import { configureTokenRefreshManager } from '@shared/utils/tokenRefreshManager';

configureTokenRefreshManager({
  onFailure: () => {
    window.location.href = '/login';
  },
});

function AppApolloProvider({ children }: { children: React.ReactNode }) {
  const apolloClient = useApollo(
    {},
    process.env.NEXT_PUBLIC_GRAPHQL_URL as string,
    process.env.NEXT_PUBLIC_WEB_SOCKET_URL as string,
  );

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
}

export default AppApolloProvider;
